import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

// 自定义锁：给跨标签页锁竞争加超时上限，避免页面卡死
function createLock() {
  return (name: string, timeout: number): Promise<() => void> => {
    return new Promise((resolve) => {
      const capped = Math.min(timeout, 10000);
      const release = () => resolve(() => {});
      if (typeof navigator === "undefined" || !("locks" in navigator)) {
        release();
        return;
      }
      try {
        void navigator.locks
          .request(name, { mode: "exclusive" }, async () => {
            release();
            await new Promise((r) => setTimeout(r, capped));
          })
          .catch(release);
      } catch {
        release();
      }
      setTimeout(release, capped);
    });
  };
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    lock: createLock(),
  },
});